import * as angular from 'angular';

function mapEndereco(address) {
  return {
    id: address.id,
    cidade: address.city,
    complemento: address.complement,
    pais: address.country,
    bairro: address.district,
    numero: address.number,
    cep: address.postalCode,
    referencia: address.reference,
    estado: address.state,
    logradouro: address.street
  };
}

function mapDestinatario(receiver: any) {
  return {
    id: receiver.id,
    nome: receiver.name,
    telefone: receiver.telephone,
    email: receiver.email,
    cpf: receiver.cpf,
    cnpj: receiver.cnpj,
    endereco: mapEndereco(receiver.address)
  };
}

function mapEncomenda(pkg: any) {
  return {
    codigoRastreamento: pkg.trackingCode,
    codigoRastreioTransportadora: pkg.carrierTrackingCode,
    id: pkg.id,
    destinatario: mapDestinatario(pkg.receiver)
  };
}

export function AtendimentoResource($resource: any, URL_API_ATENDIMENTO: string) {
  return $resource(URL_API_ATENDIMENTO + '/atendimentos/:id',
    { id: '@ticketId' },
    {
      query: {
        method: 'GET',
        interceptor: {
          response: (response: any) => {
            const instance = response.resource;

            instance.tickets.forEach((ticket: any) => {
              ticket.packages = ticket.packages.map((pkg: any) => Object.assign(mapEncomenda(pkg), pkg));
            });

            return instance;
          }
        }
      },
      setTotalAtendimentosAtualizados: {
        method: 'POST',
        url: URL_API_ATENDIMENTO + '/atendimentos/atualizacoes'
      },
      getTotalAtendimentosAtualizados: {
        method: 'GET',
        url: URL_API_ATENDIMENTO + '/atendimentos/atualizacoes'
      }
    }
  );
}
